<script>
	import InfoIcon from 'components/svg/info-icon.vue';
	import ClassroomAddonLockTooltip from 'components/classroom-addon-lock-tooltip.vue';

	export default {
		components: {
			'info-icon': InfoIcon,
			'classroom-addon-lock-tooltip': ClassroomAddonLockTooltip
		},
		props: {
			item: {
				required: true
			},
			onItemClick: {
				type: Function,
				default() {}
			},
			type: {
				default: 'checkbox'
			},
			name: {
				required: false
			},
			gcAddon: {
				type: Object
			},
			bufferText: {
				type: Boolean,
				default: false
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/flexbox';
	@import 'mixins/typography';
	@import 'config/variables';
	@import 'config/colors';

	div.input-item-with-label {
		display: flex;
		align-items: center;
		label.input-label {
			display: flex;
			align-items: center;
			cursor: pointer;
			margin-left: 0;
			margin-bottom: 0;

			> input {
				margin-right: 0.5rem;

				&.input-checkbox,
				&.input-radio {
					cursor: pointer;

					&:hover {
						border-color: $c-blue;

						& + label,
						& + label > span {
							color: $c-blue;
						}
					}
				}
			}

			&.disabled {
				opacity: 0.4;
				cursor: default;

				> input.input-checkbox,
				> input.input-radio {
					cursor: default;

					&:hover {
						border-color: $c-grey;

						& + label,
						& + label > span {
							color: $c-grey;
						}
					}
				}
			}
		}

		[data-text] {
			@include font-weight-buffer();
		}

		.icon-wrapper {
			margin-left: 0.2rem;
		}
	}
</style>
<template>
	<div class="input-item-with-label">
		<label
			class="input-label"
			v-if="item.text || item.icon"
			:class="{
				active: item.selected,
				disabled: item.disabled
			}">
			<input
				:class="[`input-${type}`, { disabled: item.disabled }]"
				:type="type"
				@change="onItemClick(item)"
				:checked="item.selected"
				:value="item.id"
				:name="name || item.id"
				:disabled="item.disabled" />
			<span class="item-label">
				<span
					:data-text="bufferText && item.text"
					v-html="item.text"></span>
				<slot></slot>
			</span>
		</label>
		<classroom-addon-lock-tooltip
			v-if="gcAddon && item.gcAddonDisabled"
			class="margin-left-xs"
			alignment="right"
			:help-text="item.text"></classroom-addon-lock-tooltip>
		<button
			v-else-if="item.icon"
			class="icon-wrapper button -link"
			v-tooltip="item.hint">
			<component
				:is="item.icon"
				:alt="item.alt"></component>
		</button>
	</div>
</template>
